import * as React from 'react';
import PropTypes from 'prop-types';
var SvgSportsWheelchairNormalLarge = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.64 17.52a6.18 6.18 0 106.17 6.17 6.18 6.18 0 00-6.17-6.17zm0 11.35a5.18 5.18 0 115.17-5.18 5.19 5.19 0 01-5.17 5.18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.34 20.39a6.25 6.25 0 00-5.56 3.41L24.27 19a.51.51 0 00-.65.27.5.5 0 00.27.66l9.16 3.78H18.83v-.05a9.28 9.28 0 10-.07 1.05h16.62a6.26 6.26 0 106-4.36zm-31.7 11.5a8.2 8.2 0 118.2-8.19 8.2 8.2 0 01-8.2 8.19zm31.7 0a5.25 5.25 0 01-5.25-5.26 5.09 5.09 0 01.25-1.52l4.81 2h.19a.5.5 0 00.47-.3.52.52 0 00-.27-.66l-4.82-2a5.25 5.25 0 114.62 7.71z"
  }));
});
SvgSportsWheelchairNormalLarge.defaultProps = {
  height: 48,
  width: 48
};
SvgSportsWheelchairNormalLarge.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgSportsWheelchairNormalLarge;